'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'split';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e254';
var svgPathData = 'M391-1c9.4-9.4 24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-80.2 0c-12.7 0-24.9 5.1-33.9 14.1L193.9 256 315.9 377.9c9 9 21.2 14.1 33.9 14.1l80.2 0-39-39c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l80 80c9.4 9.4 9.4 24.6 0 33.9l-80 80c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l39-39-80.2 0c-25.5 0-49.9-10.1-67.9-28.1L150.1 280 24 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l126.1 0 131.9-131.9c18-18 42.4-28.1 67.9-28.1l80.2 0-39-39c-9.4-9.4-9.4-24.6 0-33.9z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faSplit = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;